import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'app/theme'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  className?: string
  variant?: Variant
}

export const AnimatedLine = memo(function AnimatedLine({
  className,
  variant = 'dark',
}: Props) {
  const [ref, isVisible] = useInView({
    threshold: 0.25,
    triggerOnce: true,
  })

  return (
    <Line
      className={`${className} ${isVisible ? 'visible item-line' : 'item-line'}`}
      ref={ref}
      variant={variant}
    />
  )
})

const Line = styled.div<ContainerProps>`
  position: relative;

  ${({ variant }) => {
    switch (variant) {
      case 'dark':
        return css`
          &:after {
            background: ${theme.colors.variants.neutralDark2};
          }
        `
      case 'light':
        return css`
          &:after {
            background: ${theme.colors.variants.neutralLight4};
          }
        `
    }
  }};

  &:after {
    content: '';
    position: absolute;
    right: 0;
    left: 100%;
    width: 0;
    opacity: 0;
    width: 0;
    height: 0.0625rem;
    transition: 2s ease-in-out;
  }

  &.visible {
    &:after {
      width: 100%;
      opacity: 1;
      transition: 2s ease-in-out;
      left: 0;
      right: 100%;
    }
  }
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'dark' | 'light'
